/*************************************************************************
   Four Pathway Reference Linking System
*************************************************************************/

document.addEventListener('DOMContentLoaded', function() {
   initializeReferenceLinking();
});

function initializeReferenceLinking() {
   const pageContent = document.getElementById('page-the-liposome-advantage');
   const referencesSection = document.querySelector('.references');
   
   if (!pageContent || !referencesSection) {
       console.warn('Page content or references section not found');
       return;
   }
   
   const referenceLinks = referencesSection.querySelectorAll('ol li');
   
   // Unicode superscript to regular number mapping
   const superscriptMap = {
       '⁰': '0', '¹': '1', '²': '2', '³': '3', '⁴': '4', '⁵': '5',
       '⁶': '6', '⁷': '7', '⁸': '8', '⁹': '9'
   };
   
   // Process HTML <sup> tags
   const htmlSuperscripts = pageContent.querySelectorAll('sup');
   htmlSuperscripts.forEach((sup) => {
       const supText = sup.textContent.trim();
       if (/^\d+$/.test(supText)) {
           const referenceNumber = parseInt(supText);
           if (referenceNumber <= referenceLinks.length) {
               makeClickable(sup, referenceNumber, referenceLinks, 'html-sup');
           }
       }
   });
   
   // Process Unicode superscript characters in all text content
   const allTextNodes = getTextNodes(pageContent);
   allTextNodes.forEach((textNode) => {
       const text = textNode.textContent;
       let hasUnicodeSuperscript = false;
       
       // Check if text contains Unicode superscripts
       Object.keys(superscriptMap).forEach(superChar => {
           if (text.includes(superChar)) {
               hasUnicodeSuperscript = true;
           }
       });
       
       if (hasUnicodeSuperscript) {
           // Replace consecutive Unicode superscripts with clickable spans
           let newHTML = text;
           
           // First, find and replace consecutive superscript numbers
           const consecutiveSuperscriptRegex = /([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g;
           newHTML = newHTML.replace(consecutiveSuperscriptRegex, (match) => {
               // Convert consecutive superscripts to regular numbers
               let regularNumber = '';
               for (let i = 0; i < match.length; i++) {
                   const superChar = match[i];
                   if (superscriptMap[superChar]) {
                       regularNumber += superscriptMap[superChar];
                   }
               }
               
               const referenceNumber = parseInt(regularNumber);
               if (referenceNumber <= referenceLinks.length) {
                   return `<sup class="unicode-superscript" data-ref="${referenceNumber}">${match}</sup>`;
               }
               return match; // Return original if no valid reference
           });
           
           // Replace the text node with HTML
           if (newHTML !== text) {
               const wrapper = document.createElement('span');
               wrapper.innerHTML = newHTML;
               textNode.parentNode.replaceChild(wrapper, textNode);
           }
       }
   });
   
   // Make newly created Unicode superscript elements clickable
   const unicodeSuperscripts = pageContent.querySelectorAll('.unicode-superscript');
   unicodeSuperscripts.forEach((supElement) => {
       const referenceNumber = parseInt(supElement.getAttribute('data-ref'));
       makeClickable(supElement, referenceNumber, referenceLinks, 'unicode-sup');
   });
   
   // Add reverse linking - click on reference to highlight superscripts
   referenceLinks.forEach((reference, index) => {
       const referenceNumber = index + 1;
       
       reference.style.cursor = 'pointer';
       reference.addEventListener('click', function() {
           highlightSuperscripts(referenceNumber, pageContent);
       });
       
       reference.title = `Click to highlight superscript ${referenceNumber} in text`;
   });
}

// Helper function to get all text nodes
function getTextNodes(element) {
   const textNodes = [];
   const walker = document.createTreeWalker(
       element,
       NodeFilter.SHOW_TEXT,
       {
           acceptNode: function(node) {
               // Skip empty text nodes and nodes inside script/style tags
               if (node.textContent.trim() === '' || 
                   node.parentNode.tagName === 'SCRIPT' || 
                   node.parentNode.tagName === 'STYLE') {
                   return NodeFilter.FILTER_REJECT;
               }
               return NodeFilter.FILTER_ACCEPT;
           }
       }
   );
   
   let node;
   while (node = walker.nextNode()) {
       textNodes.push(node);
   }
   
   return textNodes;
}

// Helper function to make elements clickable
function makeClickable(element, referenceNumber, referenceLinks, type) {
   element.classList.add('clickable-reference', 'clickable-reference--active');
   element.setAttribute('data-ref-number', referenceNumber);
   element.setAttribute('data-ref-type', type);
   
   // Add click event
   element.addEventListener('click', function() {
       scrollToReference(referenceNumber, referenceLinks);
   });
   
   // Add tooltip
   element.title = `Click to view reference ${referenceNumber}`;
   
   console.log(`Linked ${type} ${referenceNumber} to reference`);
}

function scrollToReference(referenceNumber, referenceLinks) {
   const targetReference = referenceLinks[referenceNumber - 1];
   if (targetReference) {
       targetReference.scrollIntoView({
           behavior: 'smooth',
           block: 'center'
       });
       
       // Add highlight effect
       targetReference.classList.add('reference-highlight');
       setTimeout(() => {
           targetReference.classList.remove('reference-highlight');
       }, 2000);
   }
}

function highlightSuperscripts(referenceNumber, pageContent) {
   // Remove previous highlights from all clickable references
   const allClickableRefs = pageContent.querySelectorAll('.clickable-reference');
   allClickableRefs.forEach(ref => {
       ref.classList.remove('clickable-reference--highlighted');
   });
   
   // Find all superscripts that match the reference number
   const matchingSuperscripts = pageContent.querySelectorAll(`[data-ref-number="${referenceNumber}"]`);
   
   if (matchingSuperscripts.length > 0) {
       // Highlight all matching superscripts
       matchingSuperscripts.forEach((sup, index) => {
           sup.classList.add('clickable-reference--highlighted');
           
           // Scroll to first occurrence
           if (index === 0) {
               sup.scrollIntoView({
                   behavior: 'smooth',
                   block: 'center'
               });
           }
           
           // Remove highlight after 3 seconds
           setTimeout(() => {
               sup.classList.remove('clickable-reference--highlighted');
           }, 3000);
       });
       
       console.log(`Highlighted ${matchingSuperscripts.length} superscript(s) for reference ${referenceNumber}`);
   } else {
       console.warn(`No superscripts found for reference ${referenceNumber}`);
   }
}

// Export functions for potential external use
window.FourPathwayReferences = {
   initializeReferenceLinking,
   scrollToReference,
   highlightSuperscripts
};

